import React from 'react'

const ScheduledResumedJobs = () => {
  return (
    <div>ScheduledResumedJobs</div>
  )
}

export default ScheduledResumedJobs